import GenericLoader from "@/components/ui/GenericLoader";
import PageNotFound from "@/components/utils/PageNotFound";
import { useValidateSubdomain } from "@/hooks/queries/useValidateSubdomain";
import useSubdomain from "@/hooks/useSubdomain";
import AppRoutes from "@/routes/AppRoutes";
import BrandRoutes from "@/routes/BrandRoutes";
import WorkspaceRoutes from "@/routes/WorkspaceRoutes";

export default function SubdomainResolver() {
  const subdomain = useSubdomain();

  const { data: validation, isLoading } = useValidateSubdomain(subdomain);

  // No subdomain → normal Muciifi application
  if (!subdomain && !isLoading) {
    return <AppRoutes />;
  }

  // We're checking whether this can be a Muciifi subdomain
  if (isLoading) {
    return <GenericLoader type={'data'} />;
  }

  if (subdomain === "workspace") {
    return <WorkspaceRoutes />;
  }

  // Invalid/reserved subdomain
  if (!validation?.isValid || validation?.isReserved) {
    return <PageNotFound />;
  }

  // Valid potential brand subdomain
  return <BrandRoutes />;
}
